module.exports = __webpack_public_path__ + "img/宰相回宫 v3.48be8cd7.png";